import { ID } from '@models';
import { useEffect, useMemo, useState } from 'react';
import useFetch from '@hooks/useFetch';
import { components } from '@api/api';
import { useCategoryActivityFilters } from '@core/selectors/useCategoryActivityFilters';

type Request = components['schemas']['CategoryLaunchesRequest'];
type Response = components['schemas']['CategoryLaunchesBySeasonResponse'];

export function useCategoryActivityLaunchesBySeason (categoryId: ID) {
    const [data, setData] = useState<components['schemas']['CategoryLaunchesBySeasonItem'][]>([]);

    const filter = useCategoryActivityFilters();

    const payload = useMemo((): Request => {
        return {
            filter,
            id: categoryId as number,
        };
    }, [filter, categoryId]);

    const result = useFetch<Response>({
        url: '/api/Category/LaunchesBySeason',
        method: 'post',
        payload,
    });

    useEffect(() => {
        if (!result.isLoading) {
            setData(result.data?.seasons || []);
        }
    }, [result.isLoading, result.data]);

    return {
        isLoading: result.isLoading,
        data,
    }

}